import portalLogo from './logo/portal-logo.png';

export const LogoFull = () => (
  <div>
    <img style={{ height: 50, paddingLeft: 36 }} src={portalLogo} alt="" />
  </div>
);
